import { Component } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { EndasureService } from 'src/app/services/feature/Endasure/endasure.service';

@Component({
  selector: 'app-endasure-tooltip-pop-up',
  templateUrl: './endasure-tooltip-pop-up.component.html',
  styleUrls: ['./endasure-tooltip-pop-up.component.scss'],
  standalone: false
})
export class EndasureTooltipPopUPComponent {
  ToolTipTittle: any;
  ToolTipContent: any;
  ToolTipContent1: any;
  private readonly destroy$ = new Subject<void>();
  constructor(private readonly endasureService: EndasureService) { }

  ngOnInit() {
    this.endasureService.toolTipData$.pipe(takeUntil(this.destroy$)).subscribe(x => {
      this.ToolTipTittle = x[0];
      this.ToolTipContent = x[1];
      if (x[2].length > 0) {
        this.ToolTipContent1 = x[2];
      }
    })
  }
  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();

  }
  /*  if (this.subscription && this.subscription instanceof Subscription) {
            this.subscription.unsubscribe();
          } */
}
